<template>
  <el-dialog
    :visible.sync="contactBuyVisible"
    width="530px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    custom-class="contactBuydialog"
    center
    top="238px"
  >
    <template slot="title">
      <div class="contactBuy"><i class="iconfont icon-error-circle-filled"></i>{{ contactBuyData?.title }}</div>
    </template>
    <div class="helpText">{{ contactBuyData?.helpText }}</div>
    <div class="explain">
      <div class="explainDiv">
        <div class="name">{{ salesInfoGetter.userName }}</div>
        <div class="tel"><i class="iconfont icon-Telephone"></i>{{ salesInfoGetter.tel }}</div>
        <div class="phone"><i class="iconfont icon-mobile"></i>{{ salesInfoGetter.phone }}</div>
        <div class="email"><i class="iconfont icon-email"></i> <a class="emailaddress" :href="'mailto:' + salesInfoGetter.email" target="_blank" >{{salesInfoGetter.email }}</a ></div>
      </div>
    </div>
  </el-dialog>
</template>
<script>;
import { mapGetters } from 'vuex';
export default {
  props:{
    contactBuyData:{
      type:Object,
      default:null
    }
  },
  computed: {
    ...mapGetters(['salesInfoGetter']),
  },
  data() {
    return {
      contactBuyVisible: false,
    };
  },
  methods: {


  },
};
</script>
<style lang="scss" scoped>
:deep(.contactBuydialog) {
  border-radius: 8px;
  font-family: SourceHanSansCN-Regular ;
  .contactBuy {
    color: #222222;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    i{
      color: #FF7800;
      font-size: 20px;
      margin-right: 8px;
      font-weight: 400;
    }
  }
  .el-dialog__header {
    padding: 24px 24px 16px 24px;
  }
  .el-dialog__close {
    color: #999999;
    font-size: 20px;
    line-height: 28px;
  }
  .el-dialog__headerbtn {
    top: 25px;
  }
  .el-dialog__body{
    color: #555555;
    padding: 0px 24px 24px 24px ;
  }
  .helpText{
    text-align: center;
    margin-bottom: 16px;
    color: #555555;
    font-size: 14px;
    line-height: 22px;
  }
  .explain{
    background: #FBFBFB;
    width: 482px;
    height: 151px;
    margin: 0 auto;
    text-align: center;
    .explainDiv{
      text-align: left;
      padding-top: 16px;
      margin: 16px 0 16px 142px;
      .name{
         color: #222222;
         font-size: 14px;
         font-weight: 700;
         line-height: 24px;
         margin-bottom: 16px;
      }
      .tel{
        color: #222222;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        i{
          margin-right: 18px;
          color: #888;
        }
      }
      .phone{
        color: #222222;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        i{
          margin-right: 18px;
          color: #888;
        }
      }
      .email{
        color: #0863ff;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        i{
          margin-right: 18px;
          color: #888;
        }
      }
    }
  }
}
</style>